module.exports = __webpack_public_path__ + "static/media/logo-n1.e44ee50e.png";